// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"dc4b870b","329":"334618d2","498":"6e8b7572","907":"3fddb09a"}[chunkId] + ".css";
};